import { ComparatorContext, useField } from '@kizi/comparator-core';
import { Div, Span } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React, { useContext, useState } from 'react';
import { FiltersProps } from '.';
import { MobileTableSmallDesktop } from '../utils/breakpoint';
import FiltersWrapper from './Filters';

export interface FiltersButtonProps
  extends Omit<FiltersProps, 'onResetFilters'> {}

export const FiltersButton: React.FC<FiltersButtonProps> = ({
  choices,
  data,
  onChange,
  showIcon = false,
  hideResetFiltersOption = false,
  title = "Filteren",
}: FiltersButtonProps) => {
  const { name } = useContext(ComparatorContext);
  const isOs = name.includes('os-') || name === 'moneysure-event-based';
  const [isOpen, setIsOpen] = useState(false);
  const [temporaryChoices, setTemporaryChoices] = useState({});

  const filters = useField('filters');
  const filtersData = filters?.value
    ? JSON.parse(filters.value as string)
    : null;

  function resetTemporaryChoices() {
    setTemporaryChoices(JSON.parse(JSON.stringify(choices)));
  }

  return (
    <MobileTableSmallDesktop>
      <Div mr={[1, 2]} variant="filterSorting">
        <Span
          role="button"
          onClick={() => {
            setIsOpen(!isOpen);
            resetTemporaryChoices();
          }}
          style={{ cursor: 'pointer' }}
          variant="iconTextItem"
        >
          <Icon name={isOs ? 'filter' : 'filter2'} />
          {isOs ? 'Filters' : 'Filteren'}
        </Span>
      </Div>
      <FiltersWrapper
        showIcon={showIcon}
        fields={['overview.filters', 'overview.defaultFilters']}
        choices={temporaryChoices}
        data={data}
        onApplyClick={() => {
          onChange(filtersData || temporaryChoices);
          setIsOpen(false);
        }}
        onClose={() => {
          setIsOpen(false);
          resetTemporaryChoices();
        }}
        onChange={(obj) => {
          setTemporaryChoices(obj);
        }}
        hideResetFiltersOption={hideResetFiltersOption}
        onResetFilters={() => {
          resetTemporaryChoices();
        }}
        show={isOpen}
        withDesktop={false}
        title={title}
      />
    </MobileTableSmallDesktop>
  );
};
